const batchType = require('../../batchType');
const batchStatus = require('../../batchStatus');

const bat = {
  BATCH_HAS_NO_TRANSFERS: {
    message: 'Seu lote não tem transferências, registre transferências para fechá-lo',
    field: 'transfers',
    code: 'BAT_1'
  },
  BANK_ACCOUNT_NOT_FILLED_YET: {
    message:
      'Você ainda não informou os dados da conta bancária, por favor, acesse nossa aplicação web para informá-los',
    field: 'received_bank_account_id',
    code: 'BAT_2'
  },
  INVALID_BATCH_TYPE: {
    message: `O tipo do lote deve ser "${batchType.TRANSFER}" ou "${batchType.BILLET}"`,
    field: 'type',
    code: 'BAT_3'
  },
  INVALID_BATCH_NAME: {
    message: 'Nome do lote inválido',
    field: 'name',
    code: 'BAT_4'
  },
  INVALID_BATCH_UPDATE: {
    message: `O status atual do lote não permite atualização. Somente são permitidas alterações em lotes com o status ${batchStatus.DRAFT} ou ${batchStatus.FINISHED}, neste caso, apenas o campo reconciled`,
    code: 'BAT_5'
  }
};

module.exports = bat;
